import TouchableRipple from "./TouchableRipple";

export {
    TouchableRipple as default,
};
